import { Injectable } from '@angular/core';
import { ApplicationError } from '../models/application-error';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorModalComponent } from '../components/error-modal/error-modal.component';
import { of, tap } from 'rxjs';
import { ErrorModalResult } from '../models/error-modal-result';
import { ProtuneApiService } from './protune-api.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
  baseUrl: string = environment.protuneApiUrl;
  constructor(private modalService: NgbModal, private http: HttpClient) { }

  handleError(message: string = null,
    err: ApplicationError = null,
    req: HttpRequest<any> = null,
    showError: boolean = false) {

    if (showError) {
      const modal = this.modalService.open(ErrorModalComponent, {
        size: 'lg'
      });

      modal.componentInstance.title = "Application Error";
      modal.componentInstance.message = message;
      modal.componentInstance.detail = err.detail;
      modal.componentInstance.traceId = err.traceId;

      return modal.closed
        .pipe(tap((result: ErrorModalResult) => {
          if (result && result.sendDetails) {
            this.http.put(`${this.baseUrl}/error/senddetail`, {
              traceId: err.traceId,
              url: req.urlWithParams,
              body: req.serializeBody
            }).subscribe();
          }
        }));
    }

    return of();
  }
}
